// extracted by mini-css-extract-plugin
export default {"section-16":"empty-styles_section-16__EYC6r"};